// The scenario's byline, in credit order. Shared by the site header and the
// print cover wrap's spine (app/print/cover/PrintCoverSheet.tsx).
export const AUTHORS = [
  "Thomas Larsen",
  "Romeo Dean",
  "Brendan Halstead",
  "Eli Lifland",
  "Ryan Greenblatt",
  "Daniel Kokotajlo",
]
